import React from 'react'
import { FormattedMessage } from 'react-intl'

import Col from 'components/Col'
import Tooltip from 'components/Tooltip'
import InfoIcon from 'assets/icons/info-icon'
import Row from 'components/Row'
import Container from 'components/Container'

import {
  AssessmentPageSubTittle,
  AssessmentPageSubTittleIconWrapper,
  AssessmentPageSubTittleWrapper,
  AssessmentPageTittle,
  AssessmentPageTittleWrapper
} from '../../Assessment/style'

const tooltipXOffset = 0
const tooltipYOffset = 16
const ThreatsHeader = ({ title, subTitle, subTitleHint, marginBottom, firstTitle }) => {
  return (
    <Container>
      <Row>
        <Col md={8} mdOffset={2}>
          <AssessmentPageTittleWrapper firstTitle={firstTitle}>
            <AssessmentPageTittle data-test={`legend-${title}`}>
              <FormattedMessage id={title} />
            </AssessmentPageTittle>
            <AssessmentPageSubTittleWrapper marginBottom={marginBottom} data-test={`subtitle-${title}`}>
              <AssessmentPageSubTittle>
                <FormattedMessage id={subTitle} />
              </AssessmentPageSubTittle>
              {subTitleHint && (
                <Tooltip
                  style={{ zIndex: 1000 }}
                  placement="bottom"
                  trigger={['hover']}
                  align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                  overlay={{ label: title, infoTooltip: subTitleHint }}
                  type="big"
                >
                  <AssessmentPageSubTittleIconWrapper>
                    <InfoIcon />
                  </AssessmentPageSubTittleIconWrapper>
                </Tooltip>
              )}
            </AssessmentPageSubTittleWrapper>
          </AssessmentPageTittleWrapper>
        </Col>
      </Row>
    </Container>
  )
}

export default ThreatsHeader
